const SubscribeActionTypes = {};

SubscribeActionTypes.FETCH_ALL_SUBSCRIBE = 'FETCH_ALL_SUBSCRIBE';
SubscribeActionTypes.FETCH_SUBSCRIBE = 'FETCH_SUBSCRIBE';
SubscribeActionTypes.ADD_SUBSCRIBE = 'ADD_SUBSCRIBE';
SubscribeActionTypes.EDIT_SUBSCRIBE = 'EDIT_SUBSCRIBE';
SubscribeActionTypes.DELETE_SUBSCRIBE = 'DELETE_SUBSCRIBE';

export default SubscribeActionTypes;
